import React from 'react';
import './Competition.css';

const Competion = () => {
  const otherAgencies = [
    'Slow response times',
    'Single-channel focus',
    'Outdated techniques',
    'Generic or minimal research',
    'Inconsistent outsourcing',
    'One-size-fits-all solutions',
    'Transactional relationships',
  ];
  const conversions = [
    'Immediate, proactive communication',
    'Integrated multi-channel strategies',
    'Cutting-edge, data-driven methodologies',
    'Deep industry-specific insights',
    'Dedicated experts with specialized skills',
    'Tailored approaches to uniquely fit each client',
    'Long-term parternships with continous support'
  ];
  return (
    <div
      className='competition-container'
      style={{
        gap: '3rem',
        backgroundColor: 'transaprent',
      }}
    >

      <div>
        <div>
          <h1  style={{ color: 'white', textAlign: 'center', fontSize: '1.5rem' }}>
            Other agencies
          </h1>
        </div>
        <div className='conversion-container'>
          {otherAgencies.map((agency, index) => <>
            <p key={index + Math.floor(Math.random() * new Date().getTime())} style={{
              fontSize: '1rem',
              margin: '4px',
            }}>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 256 256'
                focusable='false'
                style={{
                  width: '16px',
                  height: '16px',
                  fill: 'rgb(153, 153, 153)',
                }}
              >
                <g weight='regular'>
                  <path d='M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z' />
                </g>
              </svg>
              {' ' + agency}
            </p>
          </>)}
        </div>
      </div>

      <div>
        <div>
          <h1  style={{ color: 'white', textAlign: 'center', fontSize: '1.5rem' }}>
            Future Ethics Media
          </h1>
        </div>

        <div className='conversion-container'>
          {conversions.map((conversion, index) => <>
            <p key={index} style={{
              fontSize: '1rem',
              margin: '4px',
            }}>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 256 256'
                focusable='false'
                style={{
                  width: '16px',
                  height: '16px',
                  fill: 'rgb(255, 69, 51)',
                }}
              >
                <g>
                  <path d='M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z' />
                </g>
              </svg>
              {' ' + conversion}
            </p>
          </>)}
        </div>
        
      </div>
    </div>
  );
};

export default Competion;
